module.exports = __webpack_public_path__ + "img/lalian.2d86c3a4.png";